module.exports = __webpack_public_path__ + "static/media/04_before.411c3a0b.jpg";